(function () {
  'use strict';

  /**
   * J0b staging helper — logs every client-side GA4 "purchase" hit.
   * Persists to sessionStorage so results survive GoKwik checkout navigation.
   * Remove from theme.liquid after duplicate purchase audit is complete.
   */
  var STORAGE_KEY = 'rbt_j0b_purchase_log';

  function readLog() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        return [];
      }
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function writeLog(log) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(log));
    } catch (error) {}
  }

  var log = readLog();

  function recordPurchase(source, transactionId, detail) {
    var entry = {
      at: new Date().toISOString(),
      source: source,
      transaction_id: transactionId || '(missing)',
      detail: detail || null,
    };

    log.push(entry);
    writeLog(log);
    console.warn('[J0b] purchase hit #' + log.length, entry);
  }

  function parseCollectUrl(url) {
    if (!url || url.indexOf('google-analytics.com') === -1) {
      return null;
    }

    try {
      var parsed = new URL(url, window.location.origin);
      var params = parsed.searchParams;
      var eventName = params.get('en') || params.get('ep.event_name') || '';

      if (eventName !== 'purchase') {
        return null;
      }

      return {
        transaction_id:
          params.get('ti') ||
          params.get('ep.transaction_id') ||
          params.get('epn.transaction_id') ||
          '',
      };
    } catch (error) {
      return null;
    }
  }

  function inspectDataLayerPush(args) {
    if (!args || !args.length) {
      return;
    }

    var payload = args[0];
    if (!payload || typeof payload !== 'object') {
      return;
    }

    if (payload.event !== 'purchase' && payload.en !== 'purchase') {
      return;
    }

    var ecommerce = payload.ecommerce || {};
    recordPurchase('dataLayer', ecommerce.transaction_id || payload.transaction_id || '', payload);
  }

  function buildSummary(entries) {
    var byTransaction = {};
    var bySource = {};

    entries.forEach(function (entry) {
      var tx = entry.transaction_id || 'unknown';
      byTransaction[tx] = (byTransaction[tx] || 0) + 1;
      bySource[entry.source] = (bySource[entry.source] || 0) + 1;
    });

    return {
      total_purchase_hits: entries.length,
      by_transaction_id: byTransaction,
      by_source: bySource,
      duplicate_transaction_ids: Object.keys(byTransaction).filter(function (tx) {
        return byTransaction[tx] > 1;
      }),
      note:
        entries.length === 0
          ? 'No client-side purchase hits captured. Server-side senders (Shopify native, GoKwik) only appear in GA4 DebugView.'
          : '',
    };
  }

  function patchFetch() {
    if (window.__rbtJ0bFetchPatched) {
      return;
    }

    window.__rbtJ0bFetchPatched = true;
    var originalFetch = window.fetch;

    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        var parsed = parseCollectUrl(url);

        if (parsed) {
          recordPurchase('fetch', parsed.transaction_id, url);
        }
      } catch (error) {}

      return originalFetch.apply(this, arguments);
    };
  }

  function patchBeacon() {
    if (window.__rbtJ0bBeaconPatched || !navigator.sendBeacon) {
      return;
    }

    window.__rbtJ0bBeaconPatched = true;
    var originalSendBeacon = navigator.sendBeacon.bind(navigator);

    navigator.sendBeacon = function (url, data) {
      try {
        var parsed = parseCollectUrl(url);

        if (parsed) {
          recordPurchase('sendBeacon', parsed.transaction_id, url);
        } else if (typeof data === 'string' && data.indexOf('en=purchase') !== -1) {
          recordPurchase('sendBeacon-body', '(body)', data.slice(0, 200));
        }
      } catch (error) {}

      return originalSendBeacon(url, data);
    };
  }

  function patchXHR() {
    if (window.__rbtJ0bXhrPatched) {
      return;
    }

    window.__rbtJ0bXhrPatched = true;

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._rbtJ0bUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        var parsed = parseCollectUrl(this._rbtJ0bUrl);

        if (parsed) {
          recordPurchase('xhr', parsed.transaction_id, this._rbtJ0bUrl);
        }
      } catch (error) {}

      return originalSend.apply(this, arguments);
    };
  }

  function patchDataLayer() {
    window.dataLayer = window.dataLayer || [];

    if (window.dataLayer.__rbtJ0bPatched) {
      return;
    }

    var originalPush = window.dataLayer.push.bind(window.dataLayer);

    window.dataLayer.push = function () {
      inspectDataLayerPush(arguments);
      return originalPush.apply(window.dataLayer, arguments);
    };

    window.dataLayer.__rbtJ0bPatched = true;
  }

  window.rbtJ0bPurchaseAudit = {
    log: log,
    summary: function () {
      log = readLog();
      this.log = log;
      return buildSummary(log);
    },
    print: function () {
      log = readLog();
      this.log = log;
      console.table(log);
      var summary = buildSummary(log);
      console.log('[J0b] summary', summary);
      return summary;
    },
    reset: function () {
      log.length = 0;
      writeLog(log);
      this.log = log;
    },
  };

  patchDataLayer();
  patchFetch();
  patchBeacon();
  patchXHR();

  console.info(
    '[J0b] Purchase audit active. After checkout, return to preview URL and run: rbtJ0bPurchaseAudit.print()'
  );
  console.info('[J0b] For server-side purchase duplicates, use GA4 DebugView (primary).');
})();
